module.exports = __webpack_public_path__ + "img/5-Switch-icon.9b36e95d.svg";